import axios, { API_URL } from '../../services/axios';
import { HiddenPropertyResult } from '../../types/hidden-properties';
import { updatePropertyHidden } from '../properties';
import { AppThunk } from '../store';
import { setData, setMoreData, setLoading, setError, removeHiddenProperty } from './hidden-properties.slice';

type GetHiddenProperties = (imageLocator: string) => AppThunk;
type DeleteHiddenProperty = (id: number, hardDelete: boolean) => AppThunk<Promise<boolean>>;
type SaveHiddenProperty = (id: number) => AppThunk<Promise<boolean>>;

const LIMIT = 10;

export const getHiddenProperties: GetHiddenProperties = (imageLocator) => async (dispatch) => {
  dispatch(setLoading(true));

  try {
    const result = await axios<HiddenPropertyResult>(
      {
        method: 'GET',
        url: `${API_URL}/social-group?imageLocator=${encodeURIComponent(imageLocator)}`,
        params: {
          offset: 0,
          limit: LIMIT,
          view: 'FULL',
          type: 'HIDDEN_PROPERTY',
        },
      },
      dispatch,
    );

    dispatch(setData(result.data));
  } catch (err: any) {
    dispatch(setError(err));
  } finally {
    dispatch(setLoading(false));
  }
};

export const getMoreHiddenProperties: GetHiddenProperties = (imageLocator) => async (dispatch, getState) => {
  dispatch(setLoading(true));
  const { hiddenProperties } = getState();

  try {
    const result = await axios<HiddenPropertyResult>(
      {
        method: 'GET',
        url: `${API_URL}/social-group?imageLocator=${encodeURIComponent(imageLocator)}`,
        params: {
          offset: hiddenProperties.data?.content?.length || 0,
          limit: LIMIT,
          view: 'FULL',
          type: 'HIDDEN_PROPERTY',
        },
      },
      dispatch,
    );

    dispatch(setMoreData(result.data));
  } catch (err: any) {
    dispatch(setError(err));
  } finally {
    dispatch(setLoading(false));
  }
};

export const deleteHiddenProperty: DeleteHiddenProperty = (id, hardDelete) => async (dispatch) => {
  try {
    await axios(
      {
        method: 'DELETE',
        url: `${API_URL}/hidden-property/${id}`,
      },
      dispatch,
    );

    await Promise.all([
      await dispatch(removeHiddenProperty({ id, hardDelete })),
      await dispatch(updatePropertyHidden({ hidden: false, propertyId: id })),
    ]);

    return true;
  } catch {
    return false;
  }
};

export const saveHiddenProperty: SaveHiddenProperty = (id) => async (dispatch) => {
  try {
    await axios(
      {
        method: 'PUT',
        url: `${API_URL}/hidden-property/${id}`,
      },
      dispatch,
    );

    dispatch(updatePropertyHidden({ hidden: true, propertyId: id }));

    return true;
  } catch {
    return false;
  }
};
